<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="3">
            <v-select
              v-model="status"
              :items="statusList"
              label="Trạng thái xử lý"
              outlined
              dense
              clearable
              hide-details
              placeholder="Tất cả trạng thái"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="priority"
              :items="priorityList"
              label="Mức độ ưu tiên"
              outlined
              dense
              clearable
              hide-details
              placeholder="Tất cả mức độ"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="name"
              label="Mã phiếu, người báo hoặc mô tả"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { textHelpers } from '@/helpers/TextHelper'

export default {
  name: 'MaintenanceFilter',
  data: () => ({
    status: '',
    priority: '',
    name: '',
    statusList: [
      { text: 'Chờ tiếp nhận', value: 'PENDING' },
      { text: 'Đang sửa chữa', value: 'IN_PROGRESS' },
      { text: 'Đã hoàn thành', value: 'COMPLETED' },
      { text: 'Đã hủy', value: 'CANCELLED' }
    ],
    priorityList: [
      { text: 'Thấp', value: 'LOW' },
      { text: 'Bình thường', value: 'MEDIUM' },
      { text: 'Cao', value: 'HIGH' },
      { text: 'Khẩn cấp', value: 'URGENT' }
    ]
  }),
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.status) params.status = this.status
      if (this.priority) params.priority = this.priority
      if (this.name) params.issueDescription_contains = textHelpers.removeSpaces(this.name)
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
